import {Component, OnDestroy, OnInit} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {LayoutService} from './service/app.layout.service';
import {TranslateService} from "@ngx-translate/core";
import {GlobalService} from "../services/global.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit, OnDestroy {
  
  staticModel: any[] = [];
  
  slimPlusModel: any[] = [];
  
  model2: any[] = [];
  
  isAdmin = false;
  
  menuMode = null;
  
  subscription: Subscription;
  
  constructor(
    public layoutService: LayoutService,
    private translate: TranslateService,
    public globalService: GlobalService,
  ) {
    this.subscription = this.layoutService.menuModeChange$.subscribe(menuMode => {
      this.menuMode = menuMode;
      
      if (this.menuMode === 'slim-plus') {
      
      }
    })
  }
  
  ngOnInit() {
    this.menuMode = this.layoutService.config.menuMode;
    
    this.staticModel = [
      {
        label: this.translate.instant('menu.dashboard'),
        icon: 'pi pi-home',
        routerLink: ['/']
      },
      {
        label: this.translate.instant('menu.order'),
        icon: 'pi pi-cart-plus',
        routerLink: ['/order/my']
      },
      {
        label: this.translate.instant('menu.myProduct'),
        icon: 'pi pi-shopping-bag',
        routerLink: ['/product/my']
      },
      {
        label: this.translate.instant('menu.productTag'),
        icon: 'pi pi-tags',
        routerLink: ['/product_tag']
      },
      {
        label: this.translate.instant('menu.setting'),
        icon: 'pi pi-cog',
        routerLink: ['/setting']
      },
      {
        label: this.translate.instant('menu.message'),
        icon: 'pi pi-envelope',
        routerLink: ['/message']
      }
    ];
    
    this.slimPlusModel = [
      {
        label: this.translate.instant('menu.dashboard'),
        icon: 'pi pi-home',
        routerLink: ['/']
      },
      {
        label: this.translate.instant('menu.order'),
        icon: 'pi pi-cart-plus',
        routerLink: ['/order/my']
      },
      {
        label: this.translate.instant('menu.myProduct'),
        icon: 'pi pi-shopping-bag',
        routerLink: ['/product/my']
      },
      {
        label: this.translate.instant('menu.productTag'),
        icon: 'pi pi-tags',
        routerLink: ['/product_tag']
      },
      {
        label: this.translate.instant('menu.setting'),
        icon: 'pi pi-cog',
        routerLink: ['/setting']
      },
      {
        label: this.translate.instant('menu.message'),
        icon: 'pi pi-envelope',
        routerLink: ['/message']
      }
    ];
    
    this.model2 = [
      {
        label: this.translate.instant('menu.dashboard'),
        icon: 'pi pi-home',
        routerLink: ['/']
      },
      {
        label: this.translate.instant('menu.adminProduct'),
        icon: 'pi pi-book',
        routerLink: ['/admin/product/list']
      },
      {
        label: this.translate.instant('menu.adminAddProduct'),
        icon: 'pi pi-plus',
        routerLink: ['/admin/product/add']
      }
    ];
  }
  
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
